import { map } from "lodash-es";
import { MIN_PROGRESS } from "../constants/theme";
import { IColorOffset } from "../types/theme";

export const getCovertPercent = (
  initial: number,
  total: number,
  target: number,
) => {
  const targetFinal = target / total > 1 ? 100 : (target / total) * 100;
  return {
    initial: initial / total > 1 ? 100 : (initial / total) * 100,
    target: Math.max(targetFinal, MIN_PROGRESS),
    total: 100,
  };
};

export const getSingleColorOffset = (
  colorOrigin: string,
): string | IColorOffset[] => {
  if (!colorOrigin.includes("gradient")) {
    return colorOrigin;
  }
  const listSingle = colorOrigin.split("#");
  listSingle.shift();
  const listColorOffset = map(listSingle, (c, i) => {
    const [color, offset] = c.split(" ");
    return {
      color: `#${color?.replace(/[)]/g, "")}`,
      offset: offset?.replace(/[,)]/g, "") || `${i * 100}%`,
    };
  });
  return listColorOffset;
};
